<template>
  <component :is class="my-4 space-y-0.5">
    <h1 class="text-heading-title text-fgr-primary">{{ title }}</h1>
    <p v-if="description" class="text-body-default text-fgr-secondary">{{ description }}</p>
  </component>
</template>

<script lang="ts" setup>
  const {
    title,
    description = "",
    is = "div",
  } = defineProps<{
    title: string;
    description?: string | null;
    is?: string;
  }>();
</script>
